
import React from 'react';
import cfg from '../../Config';

function OfferBox(){

    return (
        <div class="row gap-3 mt-4 align-items-start text-center mb-4">
            <div class="border rounded p-1 bg-body col-3 options-box mx-auto">
                <div className="p-3">
                    <img width="150" src="/images/offers/goingfurther_300x453_.jpg" class="img-fluid rounded-top" alt="Going Further: The Incomparable Clarence Thomas" />
                    <br />
                    <p className="text-gray fw-bold">
                        <small>$35 VALUE - <span className="text-red">FREE</span></small>
                    </p>
                </div>
                <div class="text-start head-line px-2">
                    <p className="fs-5 fw-bold mb-0">Get Ted Cruz's Going Further <span className="text-red">FREE</span> <br /></p>
                    <p className="fs-6 mb-0">Plus a Full Year of <strong>Newsmax+</strong> for <br />Just $39.99!</p>
                    <p className="text-red fs-7 fw-bold">
                        Save Over $80 Between Gift <br />
                        And Discounted Annual Subscription!
                    </p>
                </div>
                <div class="text-gray text-justify top-box-border p-3">
                    <small>
                        Get a <strong>FREE</strong> copy of <strong>Going Further</strong> with shipping included, when you start a 1-year subscription to <strong>Newsmax+</strong> for just $39.99 (*plus tax where applicable). That's a total value of $84.99! Enjoy <strong>Newsmax+</strong> for a full year, and if you decide it's not for you, cancel anytime for a full refund of the unused portion of your subscription. <strong>The book is yours to keep.</strong>
                    </small>
                </div>
            </div>
        </div>
    );
}

export const promotion = {
    offerId: cfg.promotions_offer.cthomas,
    OfferBox,
    shipping: {
        required: true,
        includePhone: true,
        requirePhone: false,
    },
    notEligible: {
        body: (<div className="mw-600 mx-auto">
            <h5 className="text-center text-red">You're Not Currently Eligible for This Offer</h5>
            <p className="text-center text-gray">But good news - you can still get the book for <strong>FREE</strong> with a subscription to <strong>Newsmax Magazine</strong>.</p>
            <p className="text-center text-gray">Get Ted Cruz's book "Going Further" <strong>FREE</strong> with our special offer.</p>
            <div className="d-flex justify-content-center">
                <a href="https://w3.newsmax.com/General/NMM/Offers/NMM-Renewal?dkt_nbr=071929z3rxt8" className="nm-btn text-center rounded mx-auto mb-5">Click Here to Learn More!</a>
            </div>
            <p className="text-gray medium-text">
                <small>
                    <strong>Need help?</strong> If you have any questions or need assistance, please contact our support team by email or phone:
                    <ul className="medium-text">
                        <li>Our customer support email is <a className="text-gray fw-bold" href="mailto:customerservice@newsmax.com">customerservice@newsmax.com</a></li>
                        <li>Our customer support number is <a className="text-gray fw-bold" href="tel:+18004854350">1-800-485-4350</a>. Office hours are Mon-Fri 8:30am - 8:30pm ET and Sat 9:00am - 5:00pm ET.</li>
                    </ul>
                </small>
            </p>
        </div>)
    },
}
